import { DesignNib, MoneySquare, Strategy } from "iconoir-react";
import type { SVGProps } from "react";

/** Figma toolkit tab icons (11043:70171) — 24px iconoir line, stroke 1.5. */
const TAB_ICON_PROPS = {
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  className: "size-6 shrink-0",
  "aria-hidden": true,
} as const;

/** Iconoir "money-operations" — not exported from iconoir-react; paths from Figma. */
function MoneyOperations(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 15H20L16 19"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 9L4 9L8 5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const STAGE_TAB_ICONS = {
  plan: <Strategy {...TAB_ICON_PROPS} />,
  price: <MoneySquare {...TAB_ICON_PROPS} />,
  fund: <MoneyOperations {...TAB_ICON_PROPS} />,
  review: <DesignNib {...TAB_ICON_PROPS} />,
} as const;
